// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__12UgD","addWidgetButton":"Header_addWidgetButton__XUeoB","dashboardTabs":"Header_dashboardTabs__1KCZX","active":"Header_active__1FkNK"};